var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 60,
    width: 46,
    height: 6,
    rx: 3,
    fill: "#C1CCF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9713 15.2676C41.2985 13.4525 38.7015 13.4525 38.0287 15.2676L35.3683 22.445C35.076 23.2335 35.794 24.024 36.6069 23.8087L43.2703 22.0438C43.8622 21.887 44.1904 21.2543 43.9775 20.6801L41.9713 15.2676Z",
    fill: "#C1CCF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8777 28.5042C46.6919 28.003 46.1558 27.7249 45.6391 27.8618L32.544 31.3302C32.2178 31.4166 31.954 31.6562 31.8367 31.9726L28.5445 40.8545C28.2522 41.643 28.9702 42.4335 29.7831 42.2182L48.874 37.1617C49.4659 37.0049 49.7941 36.3722 49.5812 35.798L46.8777 28.5042Z",
    fill: "#C1CCF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63.9062L25.0129 50.3821C25.1302 50.0657 25.394 49.8261 25.7202 49.7397L51.2428 42.9797C51.7595 42.8429 52.2956 43.1209 52.4814 43.6222L56.2356 53.7506C56.4485 54.3248 56.1203 54.9575 55.5284 55.1143L22.3338 63.9062H20Z",
    fill: "#C1CCF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6688 63.9062H60L59.1358 61.5747C58.95 61.0735 58.4139 60.7954 57.8972 60.9323L46.6688 63.9062Z",
    fill: "#C1CCF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0998 71C52.4841 71 51.4769 69.2325 52.2847 67.8249L60.1849 54.0557C60.9928 52.6481 63.0072 52.6481 63.8151 54.0557L71.7153 67.8249C72.5231 69.2325 71.5159 71 69.9002 71H54.0998Z",
    fill: "#F25467"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 66.5C63.25 67.1904 62.6904 67.75 62 67.75C61.3096 67.75 60.75 67.1904 60.75 66.5C60.75 65.8096 61.3096 65.25 62 65.25C62.6904 65.25 63.25 65.8096 63.25 66.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62 59V63",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.967c6337d6dc6e82e99cb4bed04e0fb5.svg";
export { ForwardRef as ReactComponent };